<template>
  <d-container fluid class="px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Strona główna</span>
        <h3 class="page-title">Witaj w Błonie CRM</h3>
      </d-col>
    </d-row>
    <div class="dashboard-visit" style="display: flex;">
      <d-card style="width: 100%;">
        <div class="header__title-dashboard">
          <span class="header__title-dashboard-label"><i class="material-icons">perm_contact_calendar</i> Rezerwacje: <span>{{userData.name}} {{userData.last_name}}</span></span>
        <d-row no-gutters class="page-header py-4">
          <d-col col sm="6" class="text-center header__title text-sm-left mb-4 mb-sm-0">
            <d-button class="header__title_button" @click="dateDown" theme="light">
              <i class="material-icons">keyboard_arrow_left</i>
            </d-button>
            <p class="header__title_text" :class="[dayNames[0].name === currentDay ? ( currentDay.slice(9) !== 'Niedziela' ? 'header__title_text_active' : '') : '', day === 'niedziela' ? 'header__title_text_closed' : '']">
              {{dayNames[0].name}}
            </p>
            <d-button class="header__title_button" @click="dateUp" theme="light">
              <i class="material-icons">keyboard_arrow_right</i>
            </d-button>
          </d-col>
          <d-col col sm="6" class="text-right header__title text-sm-left mb-4 mb-sm-0">
            <d-button
              theme="light"
              class="text-nowrap-dashboard"
              @click.prevent="getCurrentDate"> <i class="material-icons">double_arrow</i> Wróć do dzisiejszej daty
            </d-button>
          </d-col>
        </d-row>
        </div>
        <div class="header__row" v-if="userData.role === 'R_ADMIN' || userData.role === 'R_DEPUTY_DIRECTOR' || userData.role === 'R_HR' || userData.role === 'R_ACCOUNTANT' || userData.role === 'R_RECEPTION'">
          <d-row
            style="width: 100%;"
            class="d-flex ml-0 mb-3 page-filters">
            <validation-observer
              ref="visits-filters-form"
              tag="form"
              style="width: 100%;"
              class="d-flex">
              <div :class="{ 'form-control': true, 'is-select': true }">
                <filter-select
                  :key="selectKeyInstitutionsTrue"
                  v-model="filters.institution_id"
                  style="width: 100%;"
                  @input="validateFiltersForm"
                  :endpoint-items="'/institutions/items'"
                  :data-id="filters.institution_id  || ''"
                  :reduce="obj => obj.id"
                  :endpoint-item="'/institutions/item/'"
                  :placeholder="'Wybierz placówkę...'"
                />
              </div>
              <d-button
                theme="danger"
                outline
                class="text-nowrap ml-2"
                @click.prevent="clearFilters">Resetuj filtry</d-button>
            </validation-observer>
          </d-row>
        </div>
        <table v-if="(userData.role === 'R_ADMIN' || userData.role === 'R_DEPUTY_DIRECTOR' || userData.role === 'R_HR' || userData.role === 'R_ACCOUNTANT' || userData.role === 'R_RECEPTION') && filters.institution_id !== ''" class="table mt-0 mb-0 full-width">
          <template>
            <div class="spinner-load" v-if="spinnerSchedule">
              <div class="spinner-border spinner-border-sm decision-spinner" role="status"></div>
            </div>
          </template>
          <visits-schedule
            :key="scheduleKey || filters.institution_id"
            v-if="!spinnerSchedule"
            :time-ground="['07:00', '21:00']"
            :users-list="usersList"
            :users-list-all="usersAllList"
            :task-detail="dateList"
            :task-detail-all="dateAllList"
            :task-detail-all-free="dateAllListFree"
            :task-detail-free="dateListFree"
            :spinner-schedule="spinnerSchedule"
            :patients="patientName"
            :endpoint-institutions="institutions"
            :endpoint-patients="patients"
            :endpoint-services="services"
            :endpoint-users="users"
            :key-popup="componentKeyPopup"
            :day-name="dayNames[0].name"
            :refresh="refreshData"
            :patients-all="patientAllName"
            :current-day="startDate"
            :my-account="userData"/>
        </table>
        <table v-if="(userData.role === 'R_ADMIN' || userData.role === 'R_DEPUTY_DIRECTOR' || userData.role === 'R_HR' || userData.role === 'R_ACCOUNTANT' || userData.role === 'R_RECEPTION') && filters.institution_id === ''" class="table mt-0 mb-0 full-width">
          <d-alert
            class="mt-3 text-center emptyDay"
            show
            :theme="'primary'">
            <div class="mb-2 mt-2">Wybierz placówkę aby otrzymać listę pracowników</div>
          </d-alert>
        </table>
        <div v-if="userData.role === 'R_USER' || userData.role === 'R_COORDINATOR'" class="table mt-0 mb-0 full-width dashboard-table">
          <div v-if="loaded">
            <template>
              <div class="spinner-load" v-if="spinnerSchedule">
                <div class="spinner-border spinner-border-sm decision-spinner" role="status"></div>
              </div>
            </template>
            <div v-if="!spinnerSchedule">
              <div
                v-for="(list, index) in hardTimeList"
                :key="'hardTimeList-' + index"
                :name="'hardTimeList-' + index"
                v-if="!checkbox && day !== 'niedziela'"
                class="visits__box">
                <div
                  class="visits__box_content"
                  v-for="(visit, i) in visits"
                  v-if="(startDate === visit.date_start.slice(0, 10)) && (list.time === visit.date_start.slice(11)) && day !== 'niedziela'"
                  :key="'visits-' + i">
                  <div class="visits__box_content_visit">
                    <span>{{visit.date_start.slice(10, 13)}}</span>
                    <span>{{visit.date_start.slice(14, 16)}}</span>
                  </div>
                  <div
                    class="visits__box_content_tab visitInfo"
                  >
                    <div class="visits__box_content_tab_head">{{visit.date_start.slice(0, 10)}}</div>
                    <p class="visits__box_content_tab_name">
                      {{visit.date_start.slice(10, 16)}} - {{visit.date_end.slice(10, 16)}}
                    </p>
                  </div>
                  <div
                    class="visits__box_content_block_patient"
                  >
                    <div class="visits__box_content_block_patient_head">Pacjent:</div>
                    <p class="visits__box_content_block_patient_name" style="max-width: 10rem;"> {{visit.patientData.name + ' ' + visit.patientData.last_name}}</p>
                  </div>
                  <div
                    class="visits__box_content_block_tabs"
                  >
                    <p class="visits__box_content_block_tabs_doc" v-d-tooltip="'Specjalista:  ' + visit.userData.name + ' ' +  visit.userData.last_name">
                      <span>{{visit.userData.name.slice(0, 1)}}{{visit.userData.last_name.slice(0, 1)}}</span>
                    </p>
                  </div>
                  <div
                    class="visits__box_content_block_tabs"
                  >
                    <div class="visits__box_content_block_tabs_head">Poradnia:</div>
                    <p class="visits__box_content_block_tabs_name" style="max-width: 10rem;">{{visit.institutionData.name}}</p>
                    <p class="visits__box_content_block_tabs_rwd">
                      <i v-d-tooltip="'Poradnia: ' + visit.institutionData.name" class="material-icons visitListIcon">home_work</i>
                    </p>
                  </div>
                  <div
                    class="visits__box_content_block_tabs"
                  >
                    <div class="visits__box_content_block_tabs_head">Usługa:</div>
                    <p class="visits__box_content_block_tabs_name" style="max-width: 10rem;">{{visit.serviceData.name}}</p>
                    <p class="visits__box_content_block_tabs_rwd">
                      <i v-d-tooltip="'Usługa: ' + visit.serviceData.name" class="material-icons visitListIcon">work</i>
                    </p>
                  </div>
                  <div
                    class="visits__box_content_buttons"
                  >
                    <d-button
                      outline
                      theme="info"
                      class="mr-2"
                      @click.prevent="showModalInfo(visit)"
                      title="Podgląd">
                      <i class="material-icons">person_search</i>
                    </d-button>
                    <d-button
                      theme="primary"
                      class="mr-2"
                      @click.prevent="$router.push('/wizyty/edycja/' + visit.id)"
                      title="Edytuj">
                      <i class="material-icons">edit</i>
                    </d-button>
                    <d-button
                      theme="danger"
                      :disabled="removeInProgress"
                      @click.prevent="removeVisit(visit.id)"
                      title="Usuń">
                      <i class="material-icons">delete</i>
                    </d-button>
                  </div>
                </div>
                <div
                  v-for="visit in visits"
                  v-if="list.time !== visit.date_start.slice(11)"
                  :key="'visit_lack' + visit.id"
                  class="visits__lack"
                >
                  <div class="visits__lack_hours">
                    <span>{{list.time.slice(0, 2)}}</span>
                    <span>{{list.time.slice(3, 5)}}</span>
                  </div>
                </div>
              </div>
              <div
                class="visits__box visits__box_content"
                style="width: auto;"
                v-for="(visit, i) in visits"
                :value="startDate === visit.date_start.slice(0, 10) ? empty = true : empty = false"
                v-if="startDate === visit.date_start.slice(0, 10) && !!checkbox"
                :key="'visits-' + i">
                <div class="visits__box visits__box_content_block">
                  <div class="visits__box_content_block_visit">
                    <span>{{visit.date_start.slice(10, 13)}}</span>
                    <span>{{visit.date_start.slice(14, 16)}}</span>
                  </div>
                  <div
                    class="visits__box_content_block_patient"
                  >
                    <div class="visits__box_content_block_patient_head">Pacjent:</div>
                    <p class="visits__box_content_block_patient_name" style="max-width: 10rem;"> {{visit.patientData.name + ' ' + visit.patientData.last_name}}</p>
                  </div>
                  <div
                    class="visits__box_content_block_tabs"
                  >
                    <p class="visits__box_content_block_tabs_doc" v-d-tooltip="'Specjalista:  ' + visit.userData.name + ' ' +  visit.userData.last_name">
                      <span>{{visit.userData.name.slice(0, 1)}}{{visit.userData.last_name.slice(0, 1)}}</span>
                    </p>
                  </div>
                  <div
                    class="visits__box_content_block_tabs"
                  >
                    <div class="visits__box_content_block_tabs_head">Poradnia:</div>
                    <p class="visits__box_content_block_tabs_name" style="max-width: 10rem;">{{visit.institutionData.name}}</p>
                    <p class="visits__box_content_block_tabs_rwd">
                      <i v-d-tooltip="'Poradnia: ' + visit.institutionData.name" class="material-icons visitListIcon">home_work</i>
                    </p>
                  </div>
                  <div
                    class="visits__box_content_block_tabs"
                  >
                    <div class="visits__box_content_block_tabs_head">Usługa:</div>
                    <p class="visits__box_content_block_tabs_name" style="max-width: 10rem;">{{visit.serviceData.name}}</p>
                    <p class="visits__box_content_block_tabs_rwd">
                      <i v-d-tooltip="'Usługa: ' + visit.serviceData.name" class="material-icons visitListIcon">work</i>
                    </p>
                  </div>
                  <div
                    class="visits__box_content_block_buttons"
                  >
                    <d-button
                      outline
                      :style="((userData.role === 'R_USER' || userData.role === 'R_COORDINATOR') && userData.id !== visit.userData.id) ? 'width: 155px' : ''"
                      theme="info"
                      class="mr-2"
                      @click.prevent="showModalInfo(visit)"
                      title="Podgląd">
                      <i class="material-icons">person_search</i>
                    </d-button>
                    <d-button
                      v-if="userData.role !== 'R_USER' && userData.role !== 'R_COORDINATOR'"
                      theme="primary"
                      class="mr-2"
                      @click.prevent="$router.push('/wizyty/edycja/' + visit.id)"
                      title="Edytuj">
                      <i class="material-icons">edit</i>
                    </d-button>
                    <d-button
                      v-if="(userData.role === 'R_USER' || userData.role === 'R_COORDINATOR') && userData.id === visit.userData.id"
                      theme="primary"
                      class="mr-2"
                      @click.prevent="$router.push('/wizyty/edycja/' + visit.id)"
                      title="Edytuj1111">
                      <i class="material-icons">edit</i>
                    </d-button>
                    <d-button
                      v-if="userData.role !== 'R_USER' && userData.role !== 'R_COORDINATOR'"
                      theme="warning"
                      style="color: #fff"
                      :disabled="removeInProgress"
                      class="mr-2"
                      @click.prevent="cancelVisit(visit.id)"
                      title="Anuluj">
                      <i class="material-icons">close</i>
                    </d-button>
                    <d-button
                      v-if="(userData.role === 'R_USER' || userData.role === 'R_COORDINATOR') && userData.id === visit.userData.id"
                      theme="warning"
                      style="color: #fff"
                      :disabled="removeInProgress"
                      class="mr-2"
                      @click.prevent="cancelVisit(visit.id)"
                      title="Anuluj">
                      <i class="material-icons">close</i>
                    </d-button>
                    <d-button
                      v-if="userData.role === 'R_ADMIN'"
                      theme="danger"
                      :disabled="removeInProgress"
                      @click.prevent="removeVisit(visit.id)"
                      title="Usuń">
                      <i class="material-icons">delete</i>
                    </d-button>
                  </div>
                </div>
                <div
                  class="visits__box_content_buttons"
                >
                  <d-button
                    outline
                    :style="((userData.role === 'R_USER' || userData.role === 'R_COORDINATOR') && userData.id !== visit.userData.id) ? 'width: 75%' : ''"
                    theme="info"
                    class="mr-2"
                    @click.prevent="showModalInfo(visit)"
                    title="Podgląd">
                    <i class="material-icons">person_search</i>
                  </d-button>
                  <d-button
                    v-if="userData.role !== 'R_USER' && userData.role !== 'R_COORDINATOR'"
                    theme="primary"
                    class="mr-2"
                    @click.prevent="$router.push('/wizyty/edycja/' + visit.id)"
                    title="Edytuj">
                    <i class="material-icons">edit</i>
                  </d-button>
                  <d-button
                    v-if="(userData.role === 'R_USER' || userData.role === 'R_COORDINATOR') && userData.id === visit.userData.id"
                    theme="primary"
                    class="mr-2"
                    @click.prevent="$router.push('/wizyty/edycja/' + visit.id)"
                    title="Edytuj1111">
                    <i class="material-icons">edit</i>
                  </d-button>
                  <d-button
                    v-if="userData.role !== 'R_USER' && userData.role !== 'R_COORDINATOR'"
                    theme="warning"
                    style="color: #fff"
                    :disabled="removeInProgress"
                    class="mr-2"
                    @click.prevent="cancelVisit(visit.id)"
                    title="Anuluj">
                    <i class="material-icons">close</i>
                  </d-button>
                  <d-button
                    v-if="(userData.role === 'R_USER' || userData.role === 'R_COORDINATOR') && userData.id === visit.userData.id"
                    theme="warning"
                    style="color: #fff"
                    :disabled="removeInProgress"
                    class="mr-2"
                    @click.prevent="cancelVisit(visit.id)"
                    title="Anuluj">
                    <i class="material-icons">close</i>
                  </d-button>
                  <d-button
                    v-if="userData.role === 'R_ADMIN'"
                    theme="danger"
                    :disabled="removeInProgress"
                    @click.prevent="removeVisit(visit.id)"
                    title="Usuń">
                    <i class="material-icons">delete</i>
                  </d-button>
                </div>
              </div>
              <div v-if="visits.length !== 0">
                <d-alert
                  v-for="(visit, i) in visits"
                  :key="'visits-' + i"
                  class="mt-3 text-center emptyDay"
                  v-if="day !== 'niedziela' && (startDate !== visit.date_start.slice(0, 10)) && checkbox && i && empty !== true"
                  show
                  :theme="'info'">
                  Brak dostępnych wizyt na dzień: <b>{{startDate}}</b>
                </d-alert>
                <d-alert
                  class="mt-3 text-center"
                  v-if="day === 'niedziela'"
                  show
                  :theme="'danger'">
                  Dnia {{startDate}} wizyty są niedostępne.
                </d-alert>
              </div>
              <div v-if="visits.length === 0">
                <d-alert
                  class="mt-3 text-center"
                  show
                  :theme="'info'">
                  Brak dostępnych wizyt
                </d-alert>
              </div>
            </div>
          </div>
        </div>
        <div v-if="!loaded" class="pb-3 pt-3 text-center">
          Trwa ładowanie danych&hellip;
        </div>
        <d-alert
          v-if="loadError"
          show
          theme="warning">
          Wczytywanie danych nie powiodło się. <a hresf="javascript:window.location.reload();" class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
        </d-alert>
      </d-card>
      <visits-popup
        v-if="visit.id"
        :key="componentKeyPopup"
        :close-modal="handleCloseInfo"
        :show-modal="showModalVisit"
        :visit="visit"
        :get-day="dayNames[0].name"
        :my-account="userData"
        :reload-data="refreshData"/>
    </div>
  </d-container>
</template>
<script>
import debounce from 'lodash.debounce';
import HasFilters from '../mixins/HasFilters.vue';
import CalendarUtils from '../utils/CalendarUtils';
import ListUtils from './../utils/ListUtils.js';
import Pagination from '../components/common/Pagination.vue';
import visitHoursList from '../data/visit-hours-list';
import VisitsFilters from './visits/VisitsFilter';
import FormUtils from './../utils/FormUtils.js';
import VisitsPopup from './visits/VisitsPopup';
import VisitsCalendar from './visits/VisitsCalendar';
import VisitsSchedule from './visits/VisitsSchedule';
import FilterSelect from '@/components/others/FilterSelect';

const moment = require('moment');

export default {
  name: 'dashboard',
  mixins: [
    HasFilters
  ],
  components: {
    FilterSelect,
    VisitsCalendar,
    VisitsSchedule,
    VisitsPopup,
    'pagination': Pagination,
    VisitsFilters,
  },
  data() {
    return {
      empty: false,
      checkbox: true,
      visits: [],
      visit: [],
      users: [],
      institutions: [],
      services: [],
      patients: [],
      usersList: [],
      visitsList: [],
      usersAllList: [],
      patientName: [],
      patientAllName: [],
      dateList: [],
      dateAllList: [],
      dateAllListFree: [],
      dateListFree: [],
      usersDate: [],
      loadingData: true,
      loaded: false,
      loadError: false,
      removeInProgress: false,
      showModalVisit: false,
      closeModal: false,
      spinnerSchedule: false,
      dateContext: moment(),
      modalAdd: [],
      filters: {
        institution_id: ''
      },
      weekdays: ['Pn', 'Wt', 'Śr', 'Cz', 'Pt', 'So', 'Nd'],
      weekDayNames: ['Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota', 'Niedziela'],
      month: ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień', '', ''],
      monthShort: ['Sty', 'Lut', 'Mar', 'Kwi', 'Maj', 'Cze', 'Lip', 'Sie', 'Wrz', 'Paź', 'Lis', 'Gru', '', ''],
      monthNumber: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '', ''],
      dayNumber: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '', ''],
      firstDayPrev: '',
      dayPrev: '',
      day: '',
      componentKeyPopup: 0,
      selectKeyInstitutionsTrue: 0,
      scheduleKey: 0,
      currentDate: {
        date: 0,
        month: 0,
        year: 0,
        yearAdd: 0
      },
      currentDateCopyDate: '',
      daysCount: 1
    };
  },
  mounted () {
    if ((this.userData.role === 'R_ADMIN' || this.userData.role === 'R_DEPUTY_DIRECTOR' || this.userData.role === 'R_RECEPTION') && this.filters.institution_id !== '') {
      this.spinnerSchedule = true;
    }
    this.loadFilteredData();
    this.getUsersList();
    this.getInstitutionsList();
    this.getServicesList();
    this.userAccountGet();
  },
  created () {
    this.getCurrentDate();
  },
  watch: {
    startDate() {
      if ((this.userData.role === 'R_ADMIN' || this.userData.role === 'R_DEPUTY_DIRECTOR' || this.userData.role === 'R_RECEPTION') && this.filters.institution_id !== '') {
        this.spinnerSchedule = true;
        this.usersList = []
        this.getUsersDate();
      }
      if (this.userData.role === 'R_USER' || this.userData.role === 'R_COORDINATOR') {
        this.loadFilteredData();
      }
    },
    showModalVisit() {
      this.componentKeyPopup += 1
    },
    'currentDate.yearAdd': function () {
      this.checkTheMonthNumber();
    },
    'filters.institution_id': function () {
      if (this.userData.role === 'R_ADMIN' || this.userData.role === 'R_DEPUTY_DIRECTOR' || this.userData.role === 'R_RECEPTION') {
        this.usersDate = []
        this.dateListFree = []
        this.dateList = []
        this.usersList = []
        this.patientName = []
        this.dateAllListFree = [];
        this.dateAllList = [];
        this.usersAllList = [];
        this.patientAllName = [];
        this.spinnerSchedule = true;
        this.getUsersDate();
      }
    },
    'userData': function () {
      if (this.userData.role === 'R_ADMIN' || this.userData.role === 'R_DEPUTY_DIRECTOR' || this.userData.role === 'R_RECEPTION') {
        this.spinnerSchedule = true;
        this.getUsersDate();
      }
    },
    'currentDate.date': function () {
      this.checkTheMonthNumber();
      this.alertEmpty();
    },
  },
  computed: {
    userData () {
      return this.$store.getters.getAccount
    },
    hardTimeList () {
      return visitHoursList();
    },
    prevMonthDays () {
      let year = this.currentDate.month === 1 ? this.currentDate.year - 1 : this.currentDate.year;
      let month = this.currentDate.month === 1 ? 12 : this.currentDate.month;
      return new Date(year, month, 0).getDate();
    },
    firstMonthDay () {
      let firstDay = new Date(this.currentDate.year, this.currentDate.month, 1).getDate();
      if (this.dayPrev === 'poniedziałek') firstDay = 0;
      if (this.dayPrev === 'wtorek') firstDay = 1;
      if (this.dayPrev === 'środa') firstDay = 2;
      if (this.dayPrev === 'czwartek') firstDay = 3;
      if (this.dayPrev === 'piątek') firstDay = 4;
      if (this.dayPrev === 'sobota') firstDay = 5;
      if (this.dayPrev === 'niedziela') firstDay = 6;
      return firstDay;
    },
    currentMonthDays () {
      return new Date(this.currentDate.year, this.currentDate.month, 0).getDate();
    },
    prevMonth () {
      return new Date(this.currentDate.year, this.currentDate.month - 1, 0).getDate();
    },
    startDate () {
      return [this.currentDate.year, this.currentDate.month, this.currentDate.date].map(n => n < 10 ? '0' + n : n).join('-');
    },
    currentDay () {
      const now = new Date();
      return (now.getDate() + ' ' + (this.monthShort[now.getMonth()]) + ' - ' + (this.weekDayNames[now.getDay() - 1]))
    },
    dayNames () {
      return CalendarUtils.getDayNames(this.startDate, this.daysCount);
    },
  },
  methods: {
    userAccountGet () {
      this.$store.dispatch('userAccountGet')
    },
    rightUsersAll () {
      const users = this.usersDate;
      const patients = this.patients;
      let arrUsers = [];
      let time = [];
      let visits = [];
      let patient = [];
      let timeObj = [];
      let timeObjFree = [];
      let dateObj = [];
      for (let j = 0; j < users.length; j++) {
        const usersVisits = users[j].visits
        arrUsers[j] = {
          name: users[j].name + ' ' + users[j].last_name,
          id: users[j].id,
          is_working: users[j].is_working,
          time: [],
          visits: [],
          free_hours: users[j].free_hours
        };
        for (let i = 0; i < usersVisits.length; i++) {
          time[i] = {
            id: usersVisits[i].user_id,
            dateStart: usersVisits[i].date_start,
            dateEnd: usersVisits[i].date_end,
          };
          visits[i] = {
            visitsId: usersVisits[i].id,
            id: usersVisits[i].user_id,
          };
          arrUsers[j].time.push(time.filter(n => n.id === users[j].id));
          arrUsers[j].visits.push(visits.filter(n => n.id === users[j].id));
          for (let l = 0; l < patients.length; l++) {
            if (usersVisits[i].patient_id === patients[l].id) {
              patient[i] = patients[l].name + ' ' + patients[l].last_name;
            }
          }
        }
        if (arrUsers[j].time) {
          timeObj = arrUsers[j].time;
          for (let z = 0; z < timeObj.length; z++) {
            dateObj[j] = timeObj[z];
          }
        }
        if (arrUsers[j].free_hours) {
          timeObjFree = arrUsers[j].free_hours;
          for (let z = 0; z < timeObjFree.length; z++) {
            this.dateAllListFree[j] = timeObjFree[z];
          }
        }
        this.dateAllList = dateObj
        this.usersAllList = arrUsers.filter(n => n);
        this.patientAllName = patient.filter(n => n);
      }
    },
    rightUsers () {
      const users = this.usersDate;
      const patients = this.patients;
      let arrUsers = [];
      let time = [];
      let visits = [];
      let patient = [];
      let timeObj = [];
      let dateObj = [];
      let dateObjFree = [];
      let timeObjFree = [];
      for (let j = 0; j < users.length; j++) {
        if (users[j].visits) {
          if (users[j].visits.length) {
            const usersVisits = users[j].visits
            arrUsers[j] = {
              name: users[j].name + ' ' + users[j].last_name,
              id: users[j].id,
              is_working: users[j].is_working,
              time: [],
              visits: [],
              free_hours: users[j].free_hours
            };
            for (let i = 0; i < usersVisits.length; i++) {
              time[i] = {
                id: usersVisits[i].user_id,
                dateStart: usersVisits[i].date_start,
                dateEnd: usersVisits[i].date_end,
              };
              visits[i] = {
                visitsId: usersVisits[i].id,
                id: usersVisits[i].user_id,
              };
              arrUsers[j].time.push(time.filter(n => n.id === users[j].id));
              arrUsers[j].visits.push(visits.filter(n => n.id === users[j].id));
              for (let l = 0; l < patients.length; l++) {
                if (usersVisits[i].patient_id === patients[l].id) {
                  patient[i] = patients[l].name + ' ' + patients[l].last_name;
                }
              }
            }
            if (arrUsers[j].time) {
              timeObj = arrUsers[j].time;
              for (let z = 0; z < timeObj.length; z++) {
                dateObj[j] = timeObj[z];
              }
            }
            if (arrUsers[j].free_hours) {
              timeObjFree = arrUsers[j].free_hours;
              for (let z = 0; z < timeObjFree.length; z++) {
                dateObjFree[j] = timeObjFree[z];
              }
            }
            this.dateListFree = dateObjFree.filter(n => n)
            this.dateList = dateObj.filter(n => n)
            this.usersList = arrUsers.filter(n => n);
            this.patientName = patient.filter(n => n);
          }
        }
      }
    },
    alertEmpty () {
      this.empty = false
    },
    getUsersList () {
      let where = {
        role: ['R_USER', 'R_COORDINATOR']
      };
      if (this.filters.institution_id !== null && this.filters.institution_id) {
        where.institution_id = this.filters.institution_id;
      }
      FormUtils.loadAdditionalData(this, {
        endpoint: '/users/items',
        outputKey: 'users',
        params: {
          pagination: false,
          where
        },
      });
    },
    getInstitutionsList () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/institutions/items?ignore_institutions_filters=1',
        outputKey: 'institutions',
        params: {
          pagination: false
        },
      });
    },
    refreshData () {
      this.componentKeyPopup += 1
      this.getUsersDate();
      this.loadFilteredData();
    },
    getUsersDate () {
      this.usersDate = []
      if (Number(this.filters.institution_id) > 1) {
        FormUtils.loadAdditionalData(this, {
          endpoint: '/users/items-by-date',
          outputKey: 'usersDate',
          pagination: false,
          params: {
            date: this.startDate,
            institution_id: this.filters.institution_id ? Number(this.filters.institution_id) : 0
          },
          successAction: () => {
            setTimeout(() => {
              this.rightUsers();
              this.rightUsersAll();
            }, 400)
            this.spinnerSchedule = false;
            this.componentKeyPopup += 1
          }
        });
      }
    },
    getServicesList () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/services/items',
        outputKey: 'services',
        params: {
          pagination: false
        },
      });
    },
    dateUp () {
      if (this.currentDate.date === this.currentMonthDays) {
        this.currentDate.date = 1;
        this.monthUp();
      } else {
        this.currentDate.date += 1;
      }
    },
    dateDown () {
      if (this.currentDate.date === 1) {
        this.currentDate.date = this.prevMonthDays;
        this.monthDown();
      } else {
        this.currentDate.date -= 1;
      }
    },
    monthUp () {
      if (this.currentDate.month === 12) {
        this.currentDate.month = 1;
        this.currentDate.year += 1;
      } else {
        this.currentDate.month += 1;
      }
    },
    monthDown () {
      if (this.currentDate.month === 1) {
        this.currentDate.month = 12;
        this.currentDate.year -= 1;
      } else {
        this.currentDate.month -= 1;
      }
    },
    firstDayInLastMonth () {
      let month = this.monthNumber[this.currentDate.month - 1];
      let year = this.currentDate.year;
      this.firstDayPrev = (year + '-' + month + '-01')
    },
    getFirstDay () {
      this.dayPrev = new Date(this.firstDayPrev.toString()).toLocaleDateString(undefined, { weekday: 'long' });
    },
    checkTheMonthNumber () {
      if ((this.currentDate.date === 1) || (this.currentDate.date === 2) ||
              (this.currentDate.date === 3) || (this.currentDate.date === 4) ||
              (this.currentDate.date === 5) || (this.currentDate.date === 6) ||
              (this.currentDate.date === 7) || (this.currentDate.date === 9)) {
        this.currentDateCopyDate = '0' + this.currentDate.date
      } else {
        this.currentDateCopyDate = this.currentDate.date
      }
    },
    checkSundays () {
      this.day = new Date(this.currentDate.year + '-' + this.monthNumber[this.currentDate.month - 1] + '-' + this.currentDateCopyDate).toLocaleDateString(undefined, { weekday: 'long' });
    },
    getCurrentDate () {
      let today = new Date();
      this.currentDate.date = today.getDate();
      this.currentDate.month = today.getMonth() + 1;
      this.currentDate.year = today.getFullYear() + this.currentDate.yearAdd;
    },
    handleClose() {
      this.showModal = false
    },
    showModalInfo (visit) {
      this.showModalVisit = !this.showModalVisit;
      this.visit = visit
    },
    handleCloseInfo() {
      this.showModalVisit = false
    },
    debouncedLoadFilteredData: debounce(function () {
      this.$bus.$emit('view-filters-save');
      this.loadFilteredData();
    }, 250),
    loadFilteredDataItems () {
      let where = {
        search: this.filters.search
      };
      if (this.filters.institution_id !== null && this.filters.institution_id) {
        where.institution_id = this.filters.institution_id;
      }

      ListUtils.loadItemsData(this, {
        endpoint: '/visits/items',
        listField: 'visitsItems',
        pagination: false,
        params: {
          where
        }
      });
    },
    loadFilteredData () {
      ListUtils.loadItemsData(this, {
        endpoint: '/visits/list',
        listField: 'visits',
        pagination: false,
        params: {
          pagination: false,
          date_start: this.startDate,
          date_end: this.startDate,
          user_id: this.filters.user_id,
          institution_id: this.filters.institution_id,
          service_id: this.filters.service_id
        },
        successAction: () => {
          this.spinnerSchedule = false;
        }
      });
    },
    clearFilters () {
      this.loaded = false;
      this.loadError = false;
      this.filters = {
        search: '',
        user_id: '',
        institution_id: '',
        service_id: ''
      };
      this.selectKeyInstitutionsTrue += 1;
      this.getUsersDate();
      if (this.userData.role === 'R_RECEPTION' || this.userData.role === 'R_ADMIN') {
        setTimeout(() => {
          this.rightUsersAll();
          this.rightUsers();
        }, 1000)
      }
      this.loadFilteredData();
      this.$bus.$emit('view-filters-reset');
    },
    validateFiltersForm () {
      this.getUsersDate();
      this.$bus.$emit('pagination-reset');
      FormUtils.validate(this.$refs['visits-filters-form'], this.debouncedLoadFilteredData);
    },
    removeVisit (visitID) {
      this.removeInProgress = true;

      ListUtils.removeItem(this, {
        endpointBase: '/visits/delete/',
        id: visitID,
        successTitle: 'Usunięto wizytę',
        successText: 'Wybrana wizyta została usunięta',
        confirmTitle: 'Czy na pewno chcesz usunąć tą wizytę?',
        confirmText: 'Tej operacji nie można cofnąć',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Usuwanie wizyty nie powiodło się. Spróbuj ponownie.',
        successAction: () => {
          this.removeInProgress = false;
          this.loadFilteredData();
        },
        cancelAction: () => {
          this.removeInProgress = false;
        }
      });
    }
  }
};
</script>
<style lang="scss">
  @import '../assets/scss/visits-list.scss';
</style>
